import { useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import AssetAutocomplete from "components/holdings/AssetAutocomplete";
import { BucketActions } from "./useBucketActions";

interface BucketAddAssetRowProps {
  accountId: number;
  actions: Pick<BucketActions, "addAsset" | "isAddingAsset">;
  maxWidth?: number;
}

/**
 * Autocomplete + Add button for Buckets 1/2. Held assets show first and
 * highlighted; any asset can be added. Shared between the Buckets tab and
 * the edit modal.
 */
export const BucketAddAssetRow = ({
  accountId,
  actions,
  maxWidth,
}: BucketAddAssetRowProps) => {
  const [assetToAdd, setAssetToAdd] = useState<number | "">("");

  const handleAdd = async () => {
    if (assetToAdd === "") return;
    const ok = await actions.addAsset(assetToAdd);
    if (ok) setAssetToAdd("");
  };

  return (
    <Box display="flex" gap={1} alignItems="center">
      <Box flexGrow={1} maxWidth={maxWidth}>
        <AssetAutocomplete
          value={assetToAdd}
          onChange={setAssetToAdd}
          heldByAccountId={accountId}
          label="Add asset"
          placeholder="Assets the account holds are highlighted"
        />
      </Box>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        disabled={assetToAdd === "" || actions.isAddingAsset}
        onClick={handleAdd}
      >
        Add
      </Button>
    </Box>
  );
};
